import { FormField, InputAdornment, NumberInput } from '@cian/ui-kit';
import React, { FocusEvent } from 'react';

import { IField } from '../../types/calculator';
import { normalizeObjectCostInput } from '../../utils/checkFunctions';
import { getFieldPlaceholder } from '../../utils/getFieldPlaceholder';
import { useBaseField } from '../BaseField';

export const InputNumberField: React.FC<IField> = props => {
  const { field, fieldState } = useBaseField(props);

  const isError = fieldState.isDirty || fieldState.invalid;
  const isObjectCostField = props.name === 'objectCost';

  const handleChange = (value: number | undefined) => {
    if (isObjectCostField) {
      field.onChange(normalizeObjectCostInput(value));

      return;
    }

    field.onChange(value ? value : undefined);
  };

  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    if (isObjectCostField) {
      const raw = event.currentTarget.value.replace(/[\s\u00A0\u202F]+/g, '');
      const numericValue = raw === '' ? undefined : Number(raw);
      const normalized = normalizeObjectCostInput(
        numericValue == null || Number.isNaN(numericValue) ? undefined : numericValue,
      );

      if (field.value !== normalized) {
        field.onChange(normalized);

        return;
      }
    }

    field.onBlur();
  };

  return (
    <FormField
      label={props.label}
      errorMessage={isError ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <NumberInput
        data-testid={field.name}
        decimalDigits={props.decimalDigits || 0}
        value={Number(field.value)}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={getFieldPlaceholder(props.placeholder)}
        invalid={Boolean(fieldState.isDirty && fieldState.error)}
        disabled={props.disabled}
        name={field.name}
        ref={field.ref}
        size="M"
        rightAdornment={<InputAdornment>{props.rightAdornment}</InputAdornment>}
        min={0}
      />
    </FormField>
  );
};

InputNumberField.displayName = 'InputNumberField';
